import { render } from "./left_pie.vue?vue&type=template&id=13a9776b"
import script from "./left_pie.vue?vue&type=script&lang=js"
export * from "./left_pie.vue?vue&type=script&lang=js"
script.render = render

export default script